












import { PosRoute } from 'gl-ms-positions';
import moment from 'moment';

export default {
    data() {
        return {};
    },
    props: ['route', 'color', 'title'],
    computed: {
        details(this: any) {
            if (this.route) {
                const details = this.route.costs;
                if (details) {
                    const data = [
                        {
                            label: this.$t('fleetPlanning.costsInternalToll'),
                            data: `${Math.floor(details.driver_costs + details.vehicle_costs)} EUR / ${Math.floor(details.toll_costs)} EUR`,
                        },
                        {
                            label: this.$t('fleetPlanning.durationKm'),
                            data: `${this.printDuration(this.route.travelTime)} / ${Math.floor(this.route.distance / 1000)} km`,
                        },
                    ];

                    if (this.route.approximation) {
                        data.push({
                            label: this.$t('fleetPlanning.aproximation'),
                            data: `${this.route.approximation} m approx`,
                        });
                    }

                    return data;
                }
            }

            return [];
        },
    },

    methods: {
        printDuration(this: any, duration: number) {
            const days = moment.duration(this.route.travelTime, 'seconds').days();
            const hours = moment.duration(this.route.travelTime, 'seconds').hours();
            const minutes = moment.duration(this.route.travelTime, 'seconds').minutes();

            if (days > 0) {
                return `${days} day[s] ${hours} h and  ${minutes} m`;
            }

            return `${hours} h and  ${minutes} m`;
        },
    },
};
